import { render, staticRenderFns } from "./HandleVuelidateError.vue?vue&type=template&id=58cb767e&scoped=true&"
import script from "./HandleVuelidateError.vue?vue&type=script&lang=js&"
export * from "./HandleVuelidateError.vue?vue&type=script&lang=js&"
import style0 from "./HandleVuelidateError.vue?vue&type=style&index=0&id=58cb767e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cb767e",
  null
  
)

export default component.exports